<template>
    <el-dialog :visible.sync="clientPreferenceDialogVisible" @close="$emit('input',false)">
        <el-form :model="formData" :rules="rules" ref="preferenceForm">
            <el-row>
                <el-col :span="6">
                    <el-form-item prop="business" label="所属分类">
                        <el-select v-model="formData.business" placeholder="请选择所属分类">
                            <el-option label="合同" value="合同"></el-option>
                            <el-option label="订单" value="订单"></el-option>
                            <el-option label="结算" value="结算"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item prop="content" label="偏好描述">
                    <el-input v-model="formData.content" type="textarea" placeholder="请输入偏好描述"></el-input>
                </el-form-item>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button :loading="loading" type="primary" @click="onSubmit('preferenceForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {addClientPreference} from '@/api/api'
export default {
    name: "ClientPreferenceDialog",
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        clientName: {
            required: true
        },
        clientId: {
            required: true
        }
    },
    data() {
        return {
            clientPreferenceDialogVisible: false,
            loading: false,
            formData: {
                business: "",
                content: "",
                client_id: this.clientId,
                client_name: this.clientName
            },
            rules: {
                business: [
                    {required: true, message: "请选择所属分类", trigger: 'blur'}
                ],
                content: [
                    {required: true, message: "请输入偏好描述", trigger: 'blur'}
                ]
            }
        }
    },

    watch: {
        value(newVal) {
            this.clientPreferenceDialogVisible = newVal
        }
    },

    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.addClientPreferenceAction()
                } else {
                    return false
                }
            });
        },

        async addClientPreferenceAction() {
            this.loading = true
            let res = await addClientPreference(this.formData)
            if(res.respCode&&res.respCode=='000000') {
                this.$message.success(res.respMsg)
                this.$emit('refresh')
                this.$nextTick(()=>{
                    this.loading = false
                    this.$emit('input', false)
                })
            }else{
                this.$message.error(res.respMsg)
            }
        }
    }
}

</script>>
